import React,{useEffect,useState} from 'react';
import {getMarketingNotice} from '../../api/marketingApi';

export function useRegistrationMarketing() {
  const [notice,setNotice]=useState(null),[choices,setChoices]=useState({email:true,push:true});
  useEffect(()=>{
    const controller=new AbortController();let alive=true;
    getMarketingNotice(controller.signal).then(data=>{
      if(alive&&typeof data?.approved==='boolean'&&typeof data?.version==='string')setNotice(data);
    }).catch(()=>{});
    return()=>{alive=false;controller.abort();};
  },[]);
  return {notice,choices,setChoices,payload:notice?.approved?{...choices,noticeVersion:notice.version}:undefined};
}
export default function RegistrationMarketingChoices({value,disabled=false}) {
  const {notice,choices,setChoices}=value;
  return <fieldset className="reg-group" disabled={disabled||!notice?.approved}>
    <legend>Comunicazioni commerciali facoltative</legend>
    <label><input type="checkbox" checked={!!notice?.approved&&choices.email} onChange={e=>setChoices({...choices,email:e.target.checked})}/>
      Comunicazioni promozionali via email</label>
    <label><input type="checkbox" checked={!!notice?.approved&&choices.push} onChange={e=>setChoices({...choices,push:e.target.checked})}/>
      Comunicazioni promozionali tramite push</label>
    <details aria-label="Informazioni e privacy">
    <summary>Informazioni e privacy</summary>
    <p>Puoi registrarti senza aderire. Le due scelte sono indipendenti dalle condizioni del servizio e dai permessi del dispositivo.</p>
    <p>{notice?.emailConsent}</p>
    <p>{notice?.pushConsent}</p>
    {notice?.approved?<a href={notice.url} target="_blank" rel="noopener noreferrer">Informativa marketing — {notice.version}</a>:
      <p>Adesioni non ancora disponibili: informativa marketing in preparazione per la pubblicazione.</p>}
    <p><a href="https://www.stirup.it/privacy.html" target="_blank" rel="noopener noreferrer">Informativa privacy generale</a></p>
    </details>
  </fieldset>;
}
